/* All round states for all games */
export enum RoundStatus {
  PLACE_YOUR_BETS = 'PLACE_YOUR_BETS',
  LAST_BETS = 'LAST_BETS',
  NO_MORE_BETS = 'NO_MORE_BETS',
  GAME_RESULT = 'GAME_RESULT',
  LOADING = 'LOADING',
  RECONNECTING = 'RECONNECTING',
  DISCONNECTED = 'DISCONNECTED',
  WAIT_FOR_NEXT_GAME = 'WAIT_FOR_NEXT_GAME',
  // TODO if this a possible round status only for a game(s), add the list of games
  WAIT_FOR_NEXT_ROUND = 'WAIT_FOR_NEXT_ROUND',
  TABLE_CLOSED = 'TABLE_CLOSED',
  CANCEL_ROUND = 'CANCEL_ROUND',
  /** possible round status only for blackjack */
  INSURANCE_CALLS = 'InsuranceCalls',
  /** possible round status only for blackjack, 3cp, casino holdem */
  CALL_BETS = 'CallBets',
  /** possible round status only for 3cp, casino holdem */
  CALL_BET_DECISION = 'CallBetDecision',
  /** possible round status only for 3cp, casino holdem */
  NO_MORE_BETS_DECISION = 'NoMoreBetsDecision',
  /** possible round status only for andar bahar */
  SHUFFLE = 'SHUFFLE',
}
